unit Login;

interface

uses
  System.SysUtils, System.Classes, Vcl.Forms, JS, Web, WEBLib.Graphics, WEBLib.Controls, WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, Vcl.Controls,
  Data.DB, XData.Web.JsonDataset, XData.Web.Dataset, XData.Web.Connection, WEBLib.ExtCtrls, WEBLib.DB, WEBLib.DBCtrls, WEBLib.Grids, MobileForm;

type
  TfrmLogin = class(TForm)
    lblError: TLabel;
    edtUser: TEdit;
    edtPass: TEdit;
    btnOK: TButton;
    lblPozablenoGeslo: TButton;
    lblRegistracija: TButton;
    procedure btnOkClick(Sender: TObject);
    procedure FormShow(Sender: TObject);
    procedure lblPozablenoGesloClick(Sender: TObject);
    procedure lblRegistracijaClick(Sender: TObject);
  protected
    procedure ApplyTheme(Dark: boolean); reintroduce;
  private
    { Private declarations }
    FConnected: boolean;
    procedure ToggleOk;
    procedure WhenOnline(IsConnected: boolean);
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  frmLogin: TfrmLogin;

implementation

{$R *.dfm}

uses Main, Client.Core, Client.Settings, Auth.Service, Constants;

procedure TfrmLogin.btnOkClick(Sender: TObject);

  procedure LoginSuccess;
  begin
    modMain.StrankaId := modMain.AuthService.TokenStrankaId;
    Console.Log('modMain.StrankaId='+modMain.StrankaId.ToString);
    frmMain.ShowNarocila;
  end;

  procedure LoginError(AMsg: string);
  begin
//    ShowMessage('Error');
    lblError.Caption := 'Napačna prijava';
    Console.Log(AMsg);
  end;

begin
  if edtUser.Text='' then begin
    lblError.Caption := 'Vpiši e-poštni naslov';
    lblError.Show;

    exit;
  end;

  if edtPass.Text='' then begin
    lblError.Caption := 'Vpiši geslo';
    lblError.Show;

    exit;
  end;

//  modMain.Log(edtUser.Text+'/'+edtPass.Text);

  modMain.AuthService.LoginStranka(edtUser.Text, edtPass.Text,
    @LoginSuccess,
    @LoginError
  );

//    frmMain.ShowNarocila;

end;

procedure TfrmLogin.WhenOnline(IsConnected: boolean);
begin
  FConnected := IsConnected;
  ToggleOk;
end;

procedure TfrmLogin.ApplyTheme(Dark: boolean);
begin
  inherited;
end;

procedure TfrmLogin.FormShow(Sender: TObject);
begin
  inherited;

  modMain.StrankaEmail := '';
  modMain.StrankaId := 0;

  Console.log('REST: '+AppSettings.ServerURL);

  WhenOnline(modMain.IsConnected);modMain.OnConnected := WhenOnline;

  ToggleOk;

  ApplyTheme(AppSettings.DarkMode);
end;

procedure TfrmLogin.lblPozablenoGesloClick(Sender: TObject);
begin
//  frmmain.ShowRegistracija(gnPozabilGeslo);
  // Pošlji e-mail
end;

procedure TfrmLogin.lblRegistracijaClick(Sender: TObject);
begin
  ShowMessage('Za registracijo pokličite na telefonsko številko 05 617 50 00');
//  frmmain.ShowRegistracija(gnRegistracija);
end;

procedure TfrmLogin.ToggleOk;
begin
//  btnOk.Enabled := FConnected and modMain.connServer.Connected;
end;

procedure TfrmLogin.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lblError := TLabel.Create(Self);
  edtUser := TEdit.Create('edtUser');
  edtPass := TEdit.Create('edtPass');
  btnOK := TButton.Create('btnOK');
  lblPozablenoGeslo := TButton.Create('lblPozablenoGeslo');
  lblRegistracija := TButton.Create('lblRegistracija');

  lblError.BeforeLoadDFMValues;
  edtUser.BeforeLoadDFMValues;
  edtPass.BeforeLoadDFMValues;
  btnOK.BeforeLoadDFMValues;
  lblPozablenoGeslo.BeforeLoadDFMValues;
  lblRegistracija.BeforeLoadDFMValues;
  try
    Name := 'frmLogin';
    Width := 640;
    Height := 480;
    Color := clBtnFace;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -27;
    Font.Name := 'Segoe UI';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnShow', 'FormShow');
    lblError.SetParentComponent(Self);
    lblError.Name := 'lblError';
    lblError.Left := 0;
    lblError.Top := 443;
    lblError.Width := 640;
    lblError.Height := 37;
    lblError.Align := alBottom;
    lblError.Alignment := taCenter;
    lblError.Color := clBtnFace;
    lblError.ElementClassName := 'text-danger';
    lblError.ElementFont := efCSS;
    lblError.Font.Charset := DEFAULT_CHARSET;
    lblError.Font.Color := clRed;
    lblError.Font.Height := -27;
    lblError.Font.Name := 'Segoe UI';
    lblError.Font.Style := [];
    lblError.HeightPercent := 100.000000000000000000;
    lblError.ParentFont := False;
    lblError.WidthPercent := 100.000000000000000000;
    edtUser.SetParentComponent(Self);
    edtUser.Name := 'edtUser';
    edtUser.Left := 253;
    edtUser.Top := 56;
    edtUser.Width := 96;
    edtUser.Height := 25;
    edtUser.ChildOrder := 1;
    edtUser.ElementFont := efCSS;
    edtUser.ElementPosition := epIgnore;
    edtUser.HeightStyle := ssAuto;
    edtUser.HeightPercent := 100.000000000000000000;
    edtUser.WidthStyle := ssAuto;
    edtUser.WidthPercent := 100.000000000000000000;
    edtPass.SetParentComponent(Self);
    edtPass.Name := 'edtPass';
    edtPass.Left := 253;
    edtPass.Top := 104;
    edtPass.Width := 96;
    edtPass.Height := 25;
    edtPass.ChildOrder := 2;
    edtPass.ElementFont := efCSS;
    edtPass.ElementPosition := epIgnore;
    edtPass.HeightStyle := ssAuto;
    edtPass.HeightPercent := 100.000000000000000000;
    edtPass.WidthStyle := ssAuto;
    edtPass.WidthPercent := 100.000000000000000000;
    btnOK.SetParentComponent(Self);
    btnOK.Name := 'btnOK';
    btnOK.Left := 253;
    btnOK.Top := 200;
    btnOK.Width := 96;
    btnOK.Height := 25;
    btnOK.ChildOrder := 4;
    btnOK.ElementFont := efCSS;
    btnOK.ElementPosition := epIgnore;
    btnOK.HeightStyle := ssAuto;
    btnOK.HeightPercent := 100.000000000000000000;
    btnOK.WidthStyle := ssAuto;
    btnOK.WidthPercent := 100.000000000000000000;
    SetEvent(btnOK, Self, 'OnClick', 'btnOKClick');
    lblPozablenoGeslo.SetParentComponent(Self);
    lblPozablenoGeslo.Name := 'lblPozablenoGeslo';
    lblPozablenoGeslo.Left := 253;
    lblPozablenoGeslo.Top := 144;
    lblPozablenoGeslo.Width := 96;
    lblPozablenoGeslo.Height := 25;
    lblPozablenoGeslo.ChildOrder := 5;
    lblPozablenoGeslo.ElementFont := efCSS;
    lblPozablenoGeslo.ElementPosition := epIgnore;
    lblPozablenoGeslo.HeightStyle := ssAuto;
    lblPozablenoGeslo.HeightPercent := 100.000000000000000000;
    lblPozablenoGeslo.Visible := False;
    lblPozablenoGeslo.WidthStyle := ssAuto;
    lblPozablenoGeslo.WidthPercent := 100.000000000000000000;
    SetEvent(lblPozablenoGeslo, Self, 'OnClick', 'lblPozablenoGesloClick');
    lblRegistracija.SetParentComponent(Self);
    lblRegistracija.Name := 'lblRegistracija';
    lblRegistracija.Left := 344;
    lblRegistracija.Top := 312;
    lblRegistracija.Width := 96;
    lblRegistracija.Height := 25;
    lblRegistracija.ChildOrder := 5;
    lblRegistracija.ElementFont := efCSS;
    lblRegistracija.ElementPosition := epIgnore;
    lblRegistracija.HeightStyle := ssAuto;
    lblRegistracija.HeightPercent := 100.000000000000000000;
    lblRegistracija.WidthStyle := ssAuto;
    lblRegistracija.WidthPercent := 100.000000000000000000;
    SetEvent(lblRegistracija, Self, 'OnClick', 'lblRegistracijaClick');
  finally
    lblError.AfterLoadDFMValues;
    edtUser.AfterLoadDFMValues;
    edtPass.AfterLoadDFMValues;
    btnOK.AfterLoadDFMValues;
    lblPozablenoGeslo.AfterLoadDFMValues;
    lblRegistracija.AfterLoadDFMValues;
  end;
end;

end.
